@if(!newSummaryLoading && !exhaustionState){
<div class="flex items-center justify-between gap-2 w-full">
    <div class="flex items-center">
        <span class="font-bold white-space-nowrap">
            Summary
        </span>
        <span
            class="ml-2 p-2 flex items-center rounded-base bg-blue-50 px-2 py-1 text-xs font-medium theme-text ring-1 ring-inset ring-blue-700/10">
            <img src="icons/star.svg" class="mr-1.5 h-3 w-3 text-blue-400" alt="Star icon">
            AI Generated
        </span>
    </div>
    <div class="flex items-center gap-2">
        @if(_role === CONTRACT_USER_ROLE.OWNER || _role === CONTRACT_USER_ROLE.EDITOR){
        <app-button (clicked)="generateSummary()" [loading]="summaryLoading"
            [disabled]="summaryLoading || newSummaryLoading" loadingIcon="pi pi-refresh" icon="pi pi-refresh"
            severity="contrast" variant="outlined" />
        }
        <app-button [label]=" showSummaryList ? 'Latest' : 'History'" (clicked)=" showOrHideSummaryList()"
            icon="pi pi-eye" variant="outlined" severity="contrast" />
    </div>
</div>
}

<app-credits-overview variant="exhaustionlayout" feature="SUMMARY" [featureId]="contractId"
    [bottomImageSvg]="CONTRACT_MANAGEMENT_SVG.SUMMARY_LOADER" (resume)="fetchLatestSummary()"
    (exhaustionState)="exhaustionState = $event" />

@if(showSummaryList) {
<div class="flex flex-col text-sm p-2 pb-6">
    @if(summaryList.length == 0){
    <div class="flex justify-center items-center h-full"> No History </div>
    }@else {
    @for(summary of summaryList; track summary._id) {
    <div class="space-y-2 mt-2">
        <div (click)="fetchSummary(summary._id)"
            class="flex justify-between bg-gray-100 items-center p-2 rounded-base mb-2 cursor-pointer text-black transition-all ease-in-out hover:bg-white border">
            <div class="flex gap-2">
                <div class="flex flex-col">
                    <div class="flex flex-col">
                        <!-- <span>{{item.name}}</span> -->
                        <p class="text-black font-medium">
                            <span class="text-gray-800 ">
                                {{ summary.updatedAt | date: 'mediumDate' }} at
                                {{ summary.updatedAt | date: 'shortTime' }}
                            </span>
                        </p>
                    </div>
                    <div class="flex gap-2 mt-2">
                        <app-user-name-display [user]="summary.createdBy"
                            [variant]="'avatar-name'"></app-user-name-display>
                    </div>
                </div>
            </div>
            <div (click)="$event.stopPropagation()">
                <app-popover #menuPopover [width]="'10rem'">
                    <ng-template #trigger>
                        <i class="pi pi-ellipsis-v cursor-pointer"></i>
                    </ng-template>
                    <ng-template #body>
                        @for (item of summaryCardMenu; track item.label) {
                        <div class="flex items-center py-2 px-3 cursor-pointer hover:bg-gray-100"
                            (click)="handleMenuClick($event, summary._id, item, menuPopover)" [style]="item.style">
                            <span [class]="item.icon"></span>
                            <span class="ml-2 options">{{ item.label }}</span>
                        </div>
                        }
                    </ng-template>
                </app-popover>
            </div>
        </div>
    </div>
    }
    }
</div>
}
@else {
@if (summaryLoading)
{
<div class="flex justify-center items-center h-full">
    <p-progressSpinner class="my-4" [style]="{width: '1.875rem', height: '1.875rem'}"></p-progressSpinner>
</div>
}
@else{
@if(newSummaryLoading){
<app-generation-loader title="Summary" description="Compare the document with other documents"
    [animationData]="generationAnimationData"
    [bottomImageSvg]="CONTRACT_MANAGEMENT_SVG.SUMMARY_LOADER"></app-generation-loader>
} @else {
<div class="flex flex-col text-sm p-2 pb-6 highlight-transition rounded-base"
    [ngClass]="updateSummary ? 'bg-blue-100' : ''">
    @if(summary) {
    <div class="prose prose-compact text-justify text-sm prose-ul:pl-1 prose-ol:pl-2 2xl:prose-ul:pl-4 2xl:prose-ol:pl-3 sm:prose-ul:pl-3"
        [innerHTML]="summary | formatText" dynamicComponentRenderer [disableTooltipNavigation]="true" style="line-height: 1.5rem;">
    </div>
    <!-- <div  [innerHTML]="contractInsights | formatText" class="text-justify"></div> -->
    }
</div>
}
}
}